/** 2.5 → "2h 30m", 0.4 → "24m". Hours are the unit, minutes the resolution. */
export const formatHours = (hours) => {
  if (!hours || hours <= 0) return '0m';
  const totalMinutes = Math.round(hours * 60);
  const h = Math.floor(totalMinutes / 60);
  const m = totalMinutes % 60;
  if (h === 0) return `${m}m`;
  if (m === 0) return `${h}h`;
  return `${h}h ${m}m`;
};
